import { render, staticRenderFns } from "./view.html?vue&type=template&id=469b6949&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=469b6949&lang=less&scoped=true&"
import style1 from "./style_notebook.less?vue&type=style&index=1&id=469b6949&lang=less&scoped=true&"
import style2 from "./style_mobile.less?vue&type=style&index=2&id=469b6949&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469b6949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469b6949')) {
      api.createRecord('469b6949', component.options)
    } else {
      api.reload('469b6949', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=469b6949&scoped=true&", function () {
      api.rerender('469b6949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/block_title/index.vue"
export default component.exports